/* eslint no-undef: 0 */
const config = {};

config.hostType = 'open';

export default config;
